export const DAY_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"] as const;

export type DayKey = (typeof DAY_KEYS)[number];

export function columnToDayIdx(column: number, weekStartDay: number): number {
	return (weekStartDay + column) % 7;
}

export function dayIdxToColumn(dayIdx: number, weekStartDay: number): number {
	return (dayIdx - weekStartDay + 7) % 7;
}

export function dayKeyAt(column: number, weekStartDay: number): DayKey {
	return DAY_KEYS[columnToDayIdx(column, weekStartDay)];
}
